import React from "react";

const chairmanAwardImages = [
  {
    title: "Chairman's Award",
    image: "images/imageforchairperson.jpg",
  },
  {
    title: "Chairman's Award Distribution to the Winner Drishti",
    image: "images/imageforchairpersonsecond.jpg",
  },
  {
    title: "Chairman's Award Distribution to the Winner Optiinject",
    image: "images/imageforchairpersonthird.jpg",
  },
  {
    title: "Chairman's Award Distribution to the Winner Payzone AI",
    image: "images/imageforchairpersonfourth.jpg",
  },
];

const ChairmanAwards = () => {
  return (
    <section className="bg-black text-white">

      {/* ========= FIRST PAGE (HERO) ========= */}
      <div className="min-h-[80vh] px-6 pt-20 md:pt-24 flex items-start">
        <div className="max-w-7xl mx-auto w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 md:gap-24 items-start">

            {/* LEFT CONTENT */}
            <div>
              <h2 className="text-2xl md:text-3xl font-bold mb-6 bg-gradient-to-r from-green-400 via-red-500 to-green-500 bg-clip-text text-transparent leading-tight">
               Excellence That Inspired
              </h2>
            <div className="h-1 w-24 bg-gradient-to-r from-green-400 to-red-500 mb-6" />
 <p className="text-gray-300 text-lg leading-relaxed">
  The Chairman’s Award celebrated ideas that demonstrated{" "}
  <span className="text-white font-semibold">
    exceptional clarity, impact, and vision
  </span>.
  <br /><br />
  This recognition reflected leadership’s appreciation for solutions that were
  not only innovative, but also{" "}
  <span className="text-white font-semibold">
    meaningful for the organization’s long-term growth
  </span>.
</p>
            </div>

            {/* RIGHT IMAGE */}
            <div className="group rounded-xl overflow-hidden bg-gray-900 border border-white/10 shadow-lg transition-all duration-300 hover:shadow-[0_20px_50px_rgba(34,197,94,0.25)] hover:-translate-y-3">
              <div className="relative overflow-hidden h-96">
                <img
                  src={chairmanAwardImages[0].image}
                  alt={chairmanAwardImages[0].title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              {/* <div className="p-5 text-center bg-gray-800/60">
                <p className="text-base text-gray-100 font-semibold">
                  {chairmanAwardImages[0].title}
                </p>
              </div> */}
            </div>

          </div>
        </div>
      </div>

      {/* ========= SECOND PAGE (SCROLL SECTION) ========= */}
      <div className="px-6 ">
        <div className="max-w-7xl mx-auto">
          {/* ===== Heading ===== */}
          <h2   className="text-2xl md:text-3xl font-bold text-center mb-11
                 bg-gradient-to-r from-green-400 via-red-500 to-green-500
                 bg-clip-text text-transparent animate-gradient
                 leading-snug md:leading-snug lg:leading-snug"
    >
            Chairman Award Distribution
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            {chairmanAwardImages.slice(1).map((item, index) => (
              <div
                key={index}
                className="group rounded-xl overflow-hidden bg-black-900 border border-white/10 "
              >
                <div className="relative overflow-hidden h-56">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="p-5 text-center bg-black-800/60">
                  <p className="text-base text-black-100 font-semibold">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
};

export default ChairmanAwards;
